import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import 'hammerjs';

/**
 * Import Firebase Database for compat mode compatibility with Firebase v10+
 * This is required for AngularFireDatabase to work properly
 * @see https://github.com/angular/angularfire/blob/master/docs/version-7-upgrade.md
 */
import 'firebase/compat/database';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { getApps, initializeApp } from 'firebase/app';

if (!getApps().length && environment.firebase) {
    initializeApp(environment.firebase);
}

defineCustomElements(window);

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
